import { useSearch } from '@tanstack/react-router';

export enum QueryParam {
  ID = 'id',
  LANG = 'lang',
  SOURCE = 'source',
  STEP_TRIGGER = 'stepTrigger',
  PROFILE = 'profile',
  ONBOARDING_STEP = 'onboardingStep',
  DAY = 'day',
  SECTION = 'section',
}

export const useParseParamFromQuery = (param: QueryParam): string | null => {
  const searchParams = useSearch({ strict: false });
  const value = searchParams[param] ?? null;

  return value != null ? String(value) : null;
};
